export enum TagAlertEventType {
    Unknown = 0,
    PropertyRule = 10,
    LocationEntry = 20,
    LocationExit = 30,
    AccessRuleViolation = 40
}
